/**
 * Portapapeles del navegador con respaldo.
 *
 * `navigator.clipboard` sólo existe en contextos seguros (https o localhost), así
 * que en la instalación real (http en la red local) se usa el respaldo clásico
 * con un `<textarea>` temporal y `document.execCommand('copy')`.
 */
export async function copiarAlPortapapeles(texto: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch {
    /* se intenta el respaldo */
  }

  try {
    const area = document.createElement('textarea');
    area.value = texto;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const listo = document.execCommand('copy');
    document.body.removeChild(area);

    return listo;
  } catch {
    return false;
  }
}
